exports.TABLE_COLUMNS = {
  'invoice_column_schema': [
    {
      name: 'Item',
      editable: false
    },
    {
      name: 'Quantity',
      editable: false
    },
    {
      name: 'Weight',
      editable: false
    },
    {
      name: 'Unit price',
      editable: false
    },
    {
      name: 'Net total',
      editable: false
    },
    {
      name: 'Discount (%)',
      editable: false
    },
    {
      name: 'Total',
      editable: false
    },
  ],
  'sales_column_schema': [
    {
      name: 'Name',
      editable: false
    },
    {
      name: 'Box count',
      editable: false
    },
    {
      name: 'Quantity per box',
      editable: false
    },
    {
      name: 'Total quantity',
      editable: false
    },
    {
      name: 'Total weight',
      editable: false
    },
    {
      name: 'Batch',
      editable: false
    },
    {
      name: 'BBE',
      editable: false
    },
  ]
}